module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'groupManager'
      }
    }
  }, [_vm._v("商品分组")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("编辑商品分组")])], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "ecxForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ecxForm,
      "rules": _vm.actrules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "售货机ID",
      "prop": "kioskNo"
    }
  }, [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "机器编号"
    },
    on: {
      "change": function($event) {
        _vm.proList()
      }
    },
    model: {
      value: (_vm.ecxForm.kioskNo),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "kioskNo", $$v)
      },
      expression: "ecxForm.kioskNo"
    }
  }, [_c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == 'store001'),
      expression: "this.getcookie('storeId')=='store001'"
    }],
    attrs: {
      "label": "K1-A112",
      "value": "K1-A112"
    }
  }, [_vm._v("K1-A112")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == 'store001'),
      expression: "this.getcookie('storeId')=='store001'"
    }],
    attrs: {
      "label": "K1-A113",
      "value": "K1-A113"
    }
  }, [_vm._v("K1-A113")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == '0001'),
      expression: "this.getcookie('storeId')=='0001'"
    }],
    attrs: {
      "label": "X2-A179",
      "value": "X2-A179"
    }
  }, [_vm._v("X2-A179")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == '0001'),
      expression: "this.getcookie('storeId')=='0001'"
    }],
    attrs: {
      "label": "X2-A173",
      "value": "X2-A173"
    }
  }, [_vm._v("X2-A173")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品分组名称",
      "prop": "groupName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "商品分组名称"
    },
    model: {
      value: (_vm.ecxForm.groupName),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "groupName", $$v)
      },
      expression: "ecxForm.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "第一优先级",
      "prop": "firstPriority"
    }
  }, [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "第一优先级"
    },
    model: {
      value: (_vm.ecxForm.firstPriority),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "firstPriority", $$v)
      },
      expression: "ecxForm.firstPriority"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "0"
    }
  }, [_vm._v("无")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按商品序号升序",
      "value": "1"
    }
  }, [_vm._v("按商品序号升序")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按商品序号降序",
      "value": "2"
    }
  }, [_vm._v("按商品序号降序")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按商品销售量升序",
      "value": "3"
    }
  }, [_vm._v("按商品销售量升序")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按商品销售量降序",
      "value": "4"
    }
  }, [_vm._v("按商品销售量降序")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "第二优先级",
      "prop": "secondPriority"
    }
  }, [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "第一优先级"
    },
    model: {
      value: (_vm.ecxForm.secondPriority),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "secondPriority", $$v)
      },
      expression: "ecxForm.secondPriority"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "0"
    }
  }, [_vm._v("无")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按上架时间升序",
      "value": "1"
    }
  }, [_vm._v("按上架时间升序")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "按上架时间降序",
      "value": "2"
    }
  }, [_vm._v("按上架时间降序")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "primary",
      "disabled": _vm.isorgsubmit
    },
    on: {
      "click": function($event) {
        _vm.submitForm()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticStyle: {
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    },
    attrs: {
      "label": "商品清单",
      "name": "second"
    }
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("添加商品")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.batchDelFlag
    },
    on: {
      "click": function($event) {
        _vm.batchDel()
      }
    }
  }, [_vm._v("批量移除")]), _vm._v(" "), _c('el-select', {
    staticClass: "m-1",
    staticStyle: {
      "margin-left": "30%"
    },
    attrs: {
      "placeholder": "选择查询条件"
    },
    on: {
      "change": function($event) {
        _vm.changePro()
      }
    },
    model: {
      value: (_vm.proCondition),
      callback: function($$v) {
        _vm.proCondition = $$v
      },
      expression: "proCondition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有商品",
      "value": "0"
    }
  }, [_vm._v("所有商品")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已上架商品",
      "value": "1"
    }
  }, [_vm._v("已上架商品")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未上架商品",
      "value": "2"
    }
  }, [_vm._v("未上架商品")])], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "230px",
      "margin-left": "20px"
    },
    attrs: {
      "placeholder": "搜索商品名称"
    },
    on: {
      "change": function($event) {
        _vm.proGroupList()
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData3,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.batchhandleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kioskNo",
      "label": "售货机ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proStatus",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.proStatus != '0') ? _c('span', [_vm._v("已上架")]) : _c('span', [_vm._v("未上架")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sequenceNum",
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "80%"
          },
          attrs: {
            "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
          },
          on: {
            "change": function($event) {
              _vm.updateProGroup(scope.row)
            }
          },
          model: {
            value: (scope.row.sequenceNum),
            callback: function($$v) {
              _vm.$set(scope.row, "sequenceNum", $$v)
            },
            expression: "scope.row.sequenceNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.delProGroup(scope.row.groupId, scope.row.SKU)
            }
          }
        }, [_vm._v("移除分组")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.procurrentpage,
      "page-count": _vm.propagesCount,
      "page-sizes": _vm.propagesizes,
      "page-size": _vm.propagesize,
      "total": _vm.propagesCount,
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.proCurrentChange,
      "size-chahange": _vm.proSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "添加商品",
      "visible": _vm.dialogVisible,
      "width": "70%;height: 500px;",
      "before-close": _vm.handleClose,
      "modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "topForm",
    attrs: {
      "inline": true,
      "model": _vm.topForm
    }
  }, [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "品类"
    },
    on: {
      "change": function($event) {
        _vm.chageProList()
      }
    },
    model: {
      value: (_vm.topForm.categoriesName),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "categoriesName", $$v)
      },
      expression: "topForm.categoriesName"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部品类",
      "value": ""
    }
  }, [_vm._v("全部品类")]), _vm._v(" "), _vm._l((_vm.categories), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.categoriesName,
        "value": item.categoriesId
      }
    })
  })], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "m-1"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "查询商品名称"
    },
    model: {
      value: (_vm.topForm.proName),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "proName", $$v)
      },
      expression: "topForm.proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.chageProList()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.groupForm('topForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tablePro,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "已上架商品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kioskNo",
      "label": "售货机ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoriesName",
      "label": "品类"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addProGroup()
      }
    }
  }, [_vm._v("添 加")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45d39fa4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/group/groupModify.vue
// module id = 1059
// module chunks = 2